export default __webpack_public_path__ + "assets/3ab9222b38587c419bcf1e6ce5aa1bca.png";